import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import { Title } from '../Typography';

export const Ingredient = styled.div`
  margin-bottom: 0.625rem;
`;

export const Separator = styled.div`
  background: #e1b87f;
  width: 22.5px;
  height: 1.72px;
  display: block;
  margin-top: 0.5rem;
  margin-bottom: 1.25rem;
  @media (min-width: 768px) {
    margin-bottom: 1.875rem;
  }
`;

export const Video = styled.div`
  width: 100%;
  margin-bottom: 1.125rem;
  @media (min-width: 768px) {
    margin-bottom: 1.75rem;
  }
`;

export const NumberItem: any = tw(Title as any)`
  absolute
  -inset-0
  mt-px
  flex
  items-center
  justify-center
`;
export const SubStep = tw.p`
  font-primary
  text-sm
  md:text-base
  tracking-wide
  font-bold
`;

export const Item = tw.div`
  flex
  border-b
  border-b-solid
  border-b-[#e1b87f]
  pt-[21px]
`;
